import { Termin } from '../../../entities/Termin';
import { TermineAccordion } from '@/domain/arbeitszeiten/pages/uebersicht/Termine/TermineAccordion';
import { TooltipPopoverTrigger } from '@/domain/arbeitszeiten/pages/uebersicht/Termine/TooltipPopoverTrigger';
import { cn } from '@/lib/utils';
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '@/components/ui/popover';

export function TerminePopover({
  termine,
}: {
  termine: {
    termine?: Termin[];
    error?: string;
  };
}) {
  return (
    <Popover>
      <PopoverTrigger
        className={cn(
          'inline-flex lg:hidden',
          termine.termine.length < 1 && !termine.error
            ? 'cursor-auto'
            : 'cursor-pointer',
        )}>
        <TooltipPopoverTrigger termineCount={termine.termine.length} />
      </PopoverTrigger>
      {termine.termine.length > 0 && (
        <PopoverContent
          side="bottom"
          className="w-screen sm:w-[400px] bg-white py-2">
          <TermineAccordion termine={termine.termine} />
        </PopoverContent>
      )}
    </Popover>
  );
}
